"use client"

import { useState } from "react"
import { FuelCategoryType } from "@/types/fuelCategory.types";

export function useNoCategorySelect() {
  // Initialize with one of the allowed values
  const [selectedNoCategoryFuelValue, setSelectedNoCategoryFuelValue] = useState<FuelCategoryType>("City");

  return {
    selectedNoCategoryFuelValue,
    setSelectedNoCategoryFuelValue
  }
}
